import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { Form, Input, Button,Spin,Card,DatePicker,Select,message, Divider } from 'antd';
import { UserOutlined,DropboxOutlined,LockOutlined,MessageFilled, LoadingOutlined,RightCircleFilled, PhoneFilled, PhoneOutlined, MessageOutlined, MailOutlined, BankOutlined } from '@ant-design/icons';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { Layout, Menu, Breadcrumb,Carousel,Tabs,Collapse,Image,Drawer } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import { MdHome, MdList, MdSearch, MdShoppingCart } from 'react-icons/md';
import moment from 'moment';
import TrackingGraph from './TrackingGraph';
import TrackingTable from './TrackingTable';
import SamplesChart from './SamplesChart';
import CentralHubChart from './CentralHubChart';

var CryptoJS = require("crypto-js");

const { Header, Content, Footer } = Layout;

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Meta } = Card;
const { Option } = Select;
const { RangePicker } = DatePicker;
const FormItem=Form.Item;
const dateFormat = 'DD/MM/YYYY';


const GraphsComponentHub = () => {

  const [isMobile, setIsMobile] = useState(false);
  const [datarequested, setdatarequested] = useState(false);

  const [dateone, setdateone] = useState('');
  const [datetwo, setdatetwo] = useState('');
  const [districts, setdistricts] = useState([]);
  const [district, setdistrict] = useState('');

  const [regions, setregions] = useState([]);
  const [region, setregion] = useState('');

  const [hubs, sethubs] = useState([]);
  const [hub, sethub] = useState('');

  const [delivered_to_hubs_list, setdelivered_to_hubs_list] = useState([]);

  // Function to check if the screen size is mobile
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
  };

  useEffect(() => {
    // Check initial screen size
    checkIsMobile();
    //get date
    load_initdata()
    // Add event listener for screen resize
    window.addEventListener('resize', checkIsMobile);
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);



  //loan initial data
  const load_initdata=()=>{

    //get the dates now
    
    setdateone(getLastWeekMondayToToday().lastWeekMonday)
    setdatetwo(getLastWeekMondayToToday().today)


    let form_data1 = new FormData();
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_regions', 
    form_data1,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
      setregions(res.data.report)
    }).catch(error => console.log(error))   


    let form_data2 = new FormData();
    form_data2.append('district', district); // Initially no region selected
    
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_hubs', 
    form_data2,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
      sethubs(res.data.report)
    }).catch(error => console.log(error))   


    let form_data = new FormData();
    form_data.append('region', region);
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_districts', form_data,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
      setdistricts(res.data.report)
     // setdatarequested(false)
    } 
    )
    .catch(error => console.log(error))   

    //load initial data
    get_hubs_data()

  }



  //get dates
  const getLastWeekMondayToToday=()=> {
    const today = new Date();
  
    const day = today.getDay();
    const mondayIndex = (day + 6) % 7;
  
    const thisWeekMonday = new Date(today);
    thisWeekMonday.setDate(today.getDate() - mondayIndex);
  
    const lastWeekMonday = new Date(thisWeekMonday);
    lastWeekMonday.setDate(thisWeekMonday.getDate() - 7);
  
    const formatDate = (date) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };
  
    return {
      lastWeekMonday: formatDate(lastWeekMonday),
      today: formatDate(today)
    };


  }


  //get initial data
  const get_hubs_data=()=>{
    let form_data = new FormData();
    form_data.append('hub', localStorage.getItem("coodinated_hub"));
    setdatarequested(true)
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_hub_delivery_stats', form_data,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
        setdelivered_to_hubs_list(res.data.delivered_to_hubs_list)
        setdatarequested(false)
    })
    .catch(error => console.log(error))   
  
  }

 
    if(datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
            <Spin size="large">
            <div className="content">
              <h3>Umoja public tracker</h3>
            </div>
            </Spin> 
       </div>
      )
    }else{
      return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', margin: 20}}>
         
            <h3 style={{fontWeight:'bolder',margin:10,display:'flex',justifyContent:'center'}}>VOLUME OF SAMPLES DELIVERED</h3>
            <SamplesChart 
              delivered_to_hubs_list={delivered_to_hubs_list} 
              datarequested={datarequested}
            />
        

       </div>
       );
    }

}


export default GraphsComponentHub;
